import React, { useEffect, useState } from 'react';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Modal } from '@fiverr-private/orca';
import { isMobileView } from '../../../utils/general';
import { NightTimeBar } from '../../NightTimeBar';
import { CloseModalButton } from '../../CloseModalButton';
import ConfirmationModal from '../../ConfirmationModal';
import RecipientInfo from '../../RecipientInfo';
import PopupBody from '../PopupBody';
import PopupHeader from '../PopupHeader';
import mainClasses from '../style.module.scss';
import { useShouldEncourageAppDownload } from '../../../hooks';
import { STEPS } from '../../../constants';
import { useLoadOfferMoreGigs } from '../../../hooks/useLoadOfferMoreGigs';
import classes from './style.module.scss';

export const ContactSellerModal = ({
    onClose = noop,
    onOpen = noop,
    isOpen,
    onStepChange = noop,
    onSubmit,
    onFailure,
    isSent,
    isNight,
    onCloseButtonClick,
    showConfirmationModal,
    onCloseConfirmationModal,
    overlayClassName,
    confirmationModalOverlayClassName
}) => {
    const isMobile = isMobileView();
    const headerClassName = classNames(
        mainClasses.popUpHeader,
        classes.modalHeader,
        {
            [classes.isMobile]: isMobile,
            [classes.isSent]: isSent
        }
    );
    const headerWrapperClassName = classNames({ [mainClasses.nightHeaderWrapper]: isNight });
    const bodyClassName = classNames(classes.modalBody, mainClasses.popUpBody, { [classes.isSent]: isSent });

    const [sentHeaderDisabled, setSentHeaderDisabled] = useState(false);
    const shouldEncourageAppDownload = useShouldEncourageAppDownload();

    useLoadOfferMoreGigs(isOpen);

    useEffect(() => {
        if (isOpen){
            onOpen();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isOpen]);

    const confirmationModalClose = () => {
        onCloseConfirmationModal({ isConfirmed: false });
    };

    const confirmationModalCloseAndStay = () => {
        onCloseConfirmationModal({ isConfirmed: true });
    };

    const modalClassName = classNames(
        classes.firstMessageModal,
        mainClasses.overrideDesign,
        mainClasses.contactSellerPopUp
    );

    const handleStepChange = (step) => {
        if (step === STEPS.THANK_YOU) {
            setSentHeaderDisabled(shouldEncourageAppDownload);
        }

        onStepChange(step);
    };

    return (
        <Modal className={modalClassName} overlayClassName={overlayClassName}
            isOpen={isOpen}
            onClose={onClose}>
            <Modal.Layout>
                {isNight && <NightTimeBar/>}
                <div className={headerWrapperClassName}>
                    <Modal.Header className={headerClassName}
                        closeBtn={<CloseModalButton close={onCloseButtonClick}/>}
                        titleClassName={classes.modalTitle}>
                        <PopupHeader isSent={isSent} sentHeaderDisabled={sentHeaderDisabled}/>
                    </Modal.Header>
                </div>
                <ConfirmationModal isOpen={showConfirmationModal}
                    onClose={confirmationModalClose}
                    className={confirmationModalOverlayClassName}
                    onConfirmation={confirmationModalCloseAndStay}/>
                {isMobile && !isSent && <RecipientInfo compactView/>}
                <Modal.Body className={bodyClassName}>
                    <PopupBody onClose={onClose}
                        onSubmitSuccess={onSubmit}
                        onSubmitFailure={onFailure}
                        onStepChange={handleStepChange}/>
                </Modal.Body>
            </Modal.Layout>
        </Modal>
    );
};

ContactSellerModal.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    onStepChange: PropTypes.func,
    onOpen: PropTypes.func,
    onSubmit: PropTypes.func,
    onFailure: PropTypes.func,
    isSent: PropTypes.bool,
    isNight: PropTypes.bool,
    onCloseButtonClick: PropTypes.func,
    showConfirmationModal: PropTypes.bool,
    onCloseConfirmationModal: PropTypes.func,
    overlayClassName: PropTypes.string,
    confirmationModalOverlayClassName: PropTypes.string
};
